import { Component, OnInit, ViewChild } from '@angular/core';
import { LoginService } from '../services/login.service';
import { catchError } from 'rxjs/operators';
import { NgForm } from '@angular/forms';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { throwError } from 'rxjs';
import { BsModalService } from 'ngx-bootstrap';
import { Mode } from 'src/modules/shared/form-guide/utility/enums/enums';
import { PopupNotificationComponent } from 'src/modules/shared/request/popup-notification/popup-notification.component';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { LoaderService } from 'src/modules/shared/services/loader.service';
import { EmailLoginService } from '../services/Email-login.service';
//import { UserConfigService } from 'src/modules/shared/services/userConfig.service';
import { AppConfigService } from "../../shared/services/app-config.service";
import { CommonService } from '../../shared/services/common.service';
import { IRegisterUser } from '../../shared/interfaces/IRegisterUser';


@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})

export class ResetPasswordComponent implements OnInit {

  resetPasswordSuccessMessageHeader: string = "Password Reset SuccessFully";
  resetPasswordSuccessMessageBody: string = "Please go to Login Page ";

  //  @ViewChild("resstPasswordForm") resetPasswordForm:NgForm;*/

  invalid: boolean = false;
  activationEmail: string = '';
  activationStatus: string = '';
  UserEmail:string = '';
  verificationStatus: string;
  isSuccessActivationStatus: boolean = false;
  email: string = "";
  password: string = "";
  alertHeader: string;
  alertMsg: string;
  alertModalRef: any;
  loginError: any = "";
  errorMessages: string = "";
  workSpace: any;
  formBuilder = new FormBuilder();
  regUser: IRegisterUser;
  ResetPasswordForm: FormGroup;
  //  loginCredentials: { Email: string, Password: string };
  isProduction: boolean;
  form = { email: "email", retypePassword: "retypePassword", password: "password" }

  constructor(private loginService: EmailLoginService,
    private appConfig: AppConfigService,
    private modalService: BsModalService,
    private commonService: CommonService,
    private router: Router,
    private activatedRoute: ActivatedRoute) {
    this.isProduction = JSON.parse(this.appConfig.getAppConfig().IsProduction);
    this.regUser = {
      Email: "",
      FirstName: "",
      LastName: "",
      PhoneNumber: null,
      Nationality: "",
      PassportNumber: "",
      PasswordHash: ""

    }
  }


  ngOnInit() {
    debugger;

    this.verificationStatus = this.activatedRoute.snapshot.queryParamMap.get('verificationStatus');
    this.UserEmail = this.activatedRoute.snapshot.queryParamMap.get('UserEmail');

    this.isSuccessActivationStatus = this.verificationStatus == "Success";
    setTimeout(() => {
      this.verificationStatus = '';
      this.isSuccessActivationStatus = false;
    }, 5000);

    this.ResetPasswordForm = this.formBuilder.group({

      //email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6), Validators.pattern(
        /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*#?&^_-]).{8,}/),]],
      retypePassword: ['', [Validators.required]]
    });
    // this.ResetPasswordForm.reset(this.regUser);

    this.activatedRoute.data.subscribe((data) => { },
      (err) => {
        LoaderService.hideLoader();
        this.commonService.catchError(err);
      }, () => { }
    ) 

    LoaderService.hideLoader();
  }


  //Reset Password
  onResetPassword() {
    debugger;
    if (!this.ResetPasswordForm) return;

    this.invalid = !this.validateRetypePaassword(this.ResetPasswordForm.get('password').value, this.ResetPasswordForm.get('retypePassword').value)

    if (!this.ResetPasswordForm.valid || this.invalid) {
      this.invalid = true;
    }
    else {
      this.invalid = false
    }

    if (!this.invalid) {

      this.mapForm();
      LoaderService.showLoader();

      this.loginService.ResetPassword(this.regUser).pipe(
        catchError((error) => {
          // Handle error
          return throwError('An error occurred. Please try again later.');
        })
      ).subscribe((data) => {
        // this.showErrorModal()
        if (data.code == 200) {
          this.ResetPasswordForm.reset(this.regUser);
          this.showModal(false, this.resetPasswordSuccessMessageHeader, this.resetPasswordSuccessMessageBody, 200);
        }
        // else {
        //   this.errorMessages = data.Message.replace("Name", "Email");
        //  //this.showModal(false,data.Message.replace("Name","Email"),400);
        //}
        LoaderService.hideLoader();

      })
    }

  }

  // Map Form
  mapForm() {
    debugger;
   this.regUser.Email = this.UserEmail;
    this.regUser.PasswordHash = this.ResetPasswordForm.get('password').value;
  }


  // validate Retype Paassword
  validateRetypePaassword(password, password2) {
    debugger;
    if (password !== password2) {
      this.errorMessages = "Your password and confirmation password do not match."
    }
    return password === password2 ? true : false;
  }


  private showModal(isDraft: boolean, header: string, message: string, code: number) {
    this.alertHeader = header;

    this.alertMsg = message;

    const initialState = {
      alertMode: code == 200 ? Mode.Success : Mode.Error,
      alertHeader: this.alertHeader,
      alertMassage: `${this.alertMsg} `,
      navigateOnExit: true,
      exitNavigationURL: 'login/email',
      enableNavigation: true,
      backLableText: this.workSpace,
      navigationURL: 'home',


    };
    this.alertModalRef = this.modalService.show(PopupNotificationComponent, {
      initialState,
      ignoreBackdropClick: true,
      keyboard: false,
    });
    this.alertModalRef.content.closeBtnName = 'Close';



  }

}
